import React, {Component} from 'react';
import Waypoint from 'react-waypoint';

import { MainHeader, MainFooter } from '../Components';
import Landing from './_Landing';
import UseCases from './_UseCases';
import Services from './_Services';
import Hosting from './_Hosting';

import './Css/Home.css';

class PageHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMainHeaderTransparent: true
        };
        this.waypointPositionChanged = this.waypointPositionChanged.bind(this);
    }

    waypointPositionChanged(_props) {
        const result = ( _props.currentPosition === "inside" ) || ( _props.currentPosition === "below" )
        this.setState({
            isMainHeaderTransparent: result
        });
    }

    render() {
        const { isMainHeaderTransparent } = this.state;
        return ( 
            <div className="App">
                <MainHeader isTransparent={isMainHeaderTransparent} user={this.props.user}/>
                <Landing />
                <Waypoint onPositionChange={this.waypointPositionChanged} />
                <UseCases />
                <Services />
                <Hosting />
                <MainFooter />
            </div>
        )
    }
}

export default PageHome


// WEBPACK FOOTER //
// ./src/PageHome/index.js